<template>
	<div id="home">	
		<template v-if="!isAdmin">
			<v-img
				src="@/assets/logo.png"
				width="200"
				max-width="200"
				contain
				max-height="150"
			/>
			<span>
				Ugarit system - v{{VERSION}}
			</span>
		</template>
		<template v-else>
			<v-row style="width: 100%; height: 75%">
				<v-col
					lg="4"
					md="12"
					:class="{ 'd-flex': $vuetify.breakpoint.md }"
					class="px-1 pb-0"
					:style="$vuetify.breakpoint.lg ? { height: '100% '} : {}"
				>
					<v-card :style="$vuetify.breakpoint.lg ? { height: '46% '} : {}" >
						<v-card-title class="py-0" style="font-size: 17px">
							{{ $T('actual-amount-of-cardamom') + ':' }}
							<v-spacer />
							<span class="font-weight-bold text-h5">
								{{ rawCardamomResponse.length > 0 ? fixNumber(rawCardamomResponse.reduce((a, b) => a + b)) + ' qq' : '-'}}
							</span>
						</v-card-title>
						<v-card-text>
							<apexchart
								type="pie"
								:series="rawCardamomResponse"
								:options="chartOptionsRawCardamom"
								height="100%"
							></apexchart>
						</v-card-text>
					</v-card>

					<v-card  
						:class="{ 'mt-2': $vuetify.breakpoint.lgAndUp }" 
						:style="$vuetify.breakpoint.lg ? { height: '46% '} : {}"
					>
						<v-card-title class="py-0 text-title" style="font-size: 17px">
							{{$T('cardamom-is-restricted-to-sorting') + ': ' }}
							<v-spacer />
							<span class="font-weight-bold text-h5">
								{{ 
									inSortingCardamomResponse.length > 0
									? fixNumber(inSortingCardamomResponse.reduce((a, b) => a + b)) + ' qq' 
									: '-'
								}}
							</span>
						</v-card-title>
						<v-card-text>
							<apexchart
								type="pie"
								:series="inSortingCardamomResponse"
								:options="chartOptionsInSorting"
								height="100%"
							></apexchart>
						</v-card-text>
					</v-card>
				</v-col>
				<v-col lg="8" md="12" class="px-1 pb-0" :style="$vuetify.breakpoint.lg ? { height: '100% '} : {}">
					<v-card style="height: 94%">
						<v-card-title class="py-0 text-title" style="font-size: 17px">
							Material statistics
						</v-card-title>
						<v-card-text>
							<apexchart
								type="bar"
								:series="seriesColumn"
								:options="chartOptionsColumn"
								width="100%"
								height="380"
							></apexchart>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
			<v-row style="width: 100%" :style="$vuetify.breakpoint.mdAndUp ? { height: '25%' } : {}">
				<v-col cols="12" class="px-0 py-0 mx-0">
					<bee-handy-table
						:headers="(contractsHeaders).map(c => ({
							...c, text: c.value.includes('-') ? c.text: '', class: '', divider: c.value.includes('-')
						}))"
						:items="[]"
						dense
						:hide-default-header="false"
						hide-default-footer
						hide-no-data-area
						:data-table-props="{ disableSort: true }"
						class="statics-table"
						table-class="rounded-t-0"
						style="width: 100%"
					>
						<template v-slot:body.append>
							<!-- total-sales -->
							<tr
								class="totals-row text-center"
								:style="{ bottom: 1 * 32 + 'px'}"
							>
								<td
									colspan="4"
									class="text-start v-data-table__divider"
								>
									{{$T('total-sales')}}
								</td>
								<td
									v-for="(header, index) in itemsHeaders"
									:key="index"
									:class="header.columnClass"
									class="v-data-table__divider"
									:style="{ width: `${header.width}px`, minWidth: `${header.width}px` }"
								>
									{{(() => {
										const columnTotal = totals.totalSale.find(c => c[header.value]);
										return columnTotal
											? $options.filters.numberFormat(columnTotal[header.value])
											: 0
									})()}}
								</td>
								<td class="px-1" style="width: 66px; min-width: 66px;">
									{{$options.filters.numberFormat(fixNumber(totalSaleSum, 1))}}
								</td>
							</tr>

							<!-- sale-balance -->
							<tr
								class="totals-row text-center"
								:style="{ bottom: 0}"
							>
								<td
									colspan="4"
									class="text-start v-data-table__divider"
								>
									{{$T('sale-balance')}}
								</td>
								<td
									v-for="(header, index) in itemsHeaders"
									:key="index"
									:class="header.columnClass"
									class="v-data-table__divider"
									:style="{ width: `${header.width}px`, minWidth: `${header.width}px` }"
								>
									{{(() => {
										const columnTotal = totals.saleBalances.find(c => c[header.value]);
										return columnTotal
											? $options.filters.numberFormat(columnTotal[header.value])
											: 0
									})()}}
								</td>
								<td class="px-1" style="width: 66px; min-width: 66px;">
									{{$options.filters.numberFormat(fixNumber(saleBalancesSum, 1))}}
								</td>
							</tr>

							<!-- remaining-qty -->
							<tr
								class="totals-row text-center"
							>
								<td colspan="4" class="text-start v-data-table__divider">
									{{$T('inventory-qty')}}
								</td>
								<td
									v-for="(header, index) in itemsHeaders"
									:key="index"
									:class="header.columnClass"
									class="v-data-table__divider px-1"
									:style="{ width: `${header.width}px`, minWidth: `${header.width}px` }"
								>
									{{(() => {
										const columnTotal = totals.inventoryQuantity.find(c => c[header.value]);
										return columnTotal
											? $options.filters.numberFormat(columnTotal[header.value])
											: 0
									})()}}
								</td>
								<td class="px-1" style="width: 66px; min-width: 66px;">
									{{$options.filters.numberFormat(fixNumber(inventoryQuantitySum, 1))}}
								</td>
							</tr>

							<tr
								class="totals-row text-center"
							>
								<td colspan="4" class="text-start v-data-table__divider">
									{{$T('available-to-sell')}}
								</td>
								<td
									v-for="(header, index) in itemsHeaders"
									:key="index"
									:class="header.columnClass"
									class="v-data-table__divider px-1"
									:style="{ width: `${header.width}px`, minWidth: `${header.width}px` }"
								>
									{{(() => {
										const columnTotal = totals.ableToSell.find(c => c[header.value]);
										return columnTotal
											? $options.filters.numberFormat(columnTotal[header.value])
											: 0
									})()}}
								</td>
								<td class="px-1" style="width: 66px; min-width: 66px;">
									{{$options.filters.numberFormat(fixNumber(ableToSellSum, 1))}}
								</td>
							</tr>
						</template>
					</bee-handy-table>
				</v-col>
			</v-row>
		</template>
	</div>
</template>

<script>
import { VERSION } from '@/constants'
import { mapGetters, mapState } from 'vuex'
import { itemCategory } from '@/helpers/enums'
import { toKiloGram, fixNumber } from '@/helpers/functions';

export default {
	name: 'Home',

	data() {
		return {
			VERSION,
			series: [44, 55, 13, 43, 22],
	
			itemStatLoading: false,
			itemCategory,
			totals: {
				totalSale: [],
				saleBalances: [],
				inventoryQuantity: [],
				ableToSell: []
			},
			totalSaleSum: 0,
			saleBalancesSum: 0,
			inventoryQuantitySum: 0,
			ableToSellSum: 0
		}
	},

	computed: {
		...mapState({
			itemsStatistics: state => state.statistics.itemsStatistics,
			cardamomRootId: state => state.configs.itemsConfigs.cardamomRootId,
			itemsTree: state => state.items.itemsTree,
			owners: state => state.configs.configsTrees.owners,
			isAdmin: state => state.auth.self.isAdmin
		}),
		...mapGetters({
			getItemById: 'items/getItemById',
			getAccountById: 'accounts/getAccountById',
		}),
		inSortingCardamomResponse() {
			return this.itemsStatistics.insortingCardmmomResponse?.map(c => c.remainingQty > 0 ? fixNumber(c.remainingQty) : 0) || []
		},
		chartOptionsInSorting() { 
			return {
				series: this.itemsStatistics.insortingCardmmomResponse?.map(c => c.remainingQty > 0 ? fixNumber(c.remainingQty) : 0) || [],
				chart: {
					width: 320,
					type: 'pie',
					animations: {
						enabled: true,
						easing: 'linear',
						speed: 1000,
						dynamicAnimation: {
							enabled: true,
							speed: 350
						}
					}
				},
				labels: this.labelsInSortingCardamom ? this.labelsInSortingCardamom : [],
				dataLabels: {
					formatter: (val, { seriesIndex, w }) => w.config.series[seriesIndex]
				},

				responsive: [{
					breakpoint: 480,
					options: {
						chart: {
							width: 300
						},
						legend: {
							position: 'bottom'
						}
					}
				}],
				fill: {
					colors: ['#015931', '#03ac5f', '#cdecde', '#89d3b1', '#5fca99']
				}
			}
		},

		labelsInSortingCardamom() {
			return this.itemsStatistics?.insortingCardmmomResponse?.map(c => this.getOwnerById(c.ownerId)) || []
		},
		labelsRawCardamom() {
			return this.itemsStatistics?.rawCardmmomResponse?.map(c => this.getOwnerById(c.ownerId)) || []
		},
		rawCardamomResponse() {
			return this.itemsStatistics.rawCardmmomResponse?.map(c => c.remainingQty > 0 ? fixNumber(c.remainingQty) : 0) || []
		},
		chartOptionsRawCardamom() { 
			return {
				series: this.itemsStatistics.rawCardmmomResponse?.map(c => c.remainingQty > 0 ? fixNumber(c.remainingQty) : 0) || [],
				chart: {
					width: 320,
					type: 'pie',
					animations: {
						enabled: true,
						easing: 'easeinout',
						speed: 800,
						animateGradually: {
							enabled: true,
							delay: 150
						},
						dynamicAnimation: {
							enabled: true,
							speed: 350
						}
					}
				},
				labels: this.labelsRawCardamom ? this.labelsRawCardamom : [],
				dataLabels: {
					formatter: (val, { seriesIndex, w }) => w.config.series[seriesIndex]
				},
				responsive: [{
					breakpoint: 480,
					options: {
						chart: {
							width: 200
						},
						legend: {
							position: 'bottom'
						}
					}
				}],
				fill: {
					colors: ['#015931', '#03ac5f', '#cdecde', '#89d3b1', '#5fca99']
				}
			}
		},

		// 
		totalSales() {
			const totalSales = []
			const sales = this.itemsStatistics.totalSaleResponses
			this.categories.forEach((e) => {
				if (sales?.find(c => c.itemId === e.id)) {
					totalSales.push(
						fixNumber(sales?.find(c => c.itemId === e.id).totalSales)
					)
				} else {
					totalSales.push(
						0
					)
				}
			})
			
			return totalSales.map(c => c > 0 ? c : 0)
		},
		saleBalance() {
			const saleBalance = []
			const sales = this.itemsStatistics.saleBalanceResponses
			this.categories.forEach((e) => {
				if (sales?.find(c => c.itemId === e.id)) {
					saleBalance.push(
						fixNumber(sales?.find(c => c.itemId === e.id).totalSales)
					)
				} else {
					saleBalance.push(
						0
					)
				}
			})
			
			return saleBalance.map(c => c > 0 ? c : 0)
		},

		inventoryItems() {
			const inventoryItems = []
			const items = this.itemsStatistics.inventoryItemsResponses
			this.categories.forEach((e) => {
				if (items?.find(c => c.itemId === e.id)) {
					inventoryItems.push(
						fixNumber(items?.find(c => c.itemId === e.id).remainingQty)
					)
				} else {
					inventoryItems.push(
						0
					)
				}
			})
			return inventoryItems.map(c => c > 0 ? c : 0)
		},
		seriesColumn() {
			return [
				{
					name: this.$T('total-sales'),
					data: this.itemsStatistics.saleBalanceResponses?.length ? this.totalSales : []
				},
				{
					name: this.$T('sale-balance-table'),
					data: this.itemsStatistics.totalSaleResponses?.length ? this.saleBalance : []
				}, 
				{
					name: this.$T('items-in-inventory'),
					data: this.itemsStatistics.inventoryItemsResponses?.length ? this.inventoryItems : []
				}
			]
		},

		chartOptionsColumn () {
			return {
				chart: {
					type: 'bar',
					height: 350,
					animations: {
						enabled: true,
						easing: 'linear',
						speed: 1000,
						dynamicAnimation: {
							enabled: true,
							speed: 350
						}
					}
				},
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: '55%',
						borderRadius: 5,
						borderRadiusApplication: 'end'
					},
				},
				dataLabels: {
					// enabled: false
					formatter: (val, { seriesIndex, w }) => w.config.series[seriesIndex]
				},
				stroke: {
					show: true,
					width: 2,
					colors: ['transparent']
				},
				xaxis: {
					categories: this.categories.map(c => c.name),
				},
				fill: {
					opacity: 1
				},
				tooltip: {
					y: {
						formatter: function (val) {
							return Intl.NumberFormat().format(val)
						}
					}
				}
			}
		},

		categories() {
			const subTreeItemId = this.cardamomRootId || this.itemsTree[0].id;
			if (!subTreeItemId) return;
			const subTree = this.itemsTree.find(c => c.id === subTreeItemId);
			if (!subTree?.children) return [];
			const categories = [];		

			subTree.children.filter(c => c.itemCategory === itemCategory.commercial).forEach((c, i) => {
				if (c.children.length) {
					c.children.forEach(e => {
						categories.push({
							name: e.name,
							id: e.id
						})
					});
				} else {
					categories.push({
						name: c.name,
						id: c.id
					});
				}
			})

			return categories;
		},

		contractsHeaders() {
			const headers = [
				{
					text: this.$T('headers.no'),
					name: 'contractNo',
					value: 'contractNo',
					width: 40,
					noNotAvailableText: true,
					setValueExpr: val => val + 1,
				},
				{
					text: this.$T('headers.client'),
					name: 'clientId',
					value: 'clientId',
					cellClass: 'text-caption',
					setValueExpr: val => this.getAccountById(val)?.name
				},
				/* {
					text: this.$T('headers.country'),
					name: 'country',
					value: 'country',
				}, */
				{
					text: this.$T('headers.date'),
					name: 'date',
					value: 'date',
					type: 'date',
					cellClass: 'text-caption',
					width: 78
				},
				{
					text: this.$T('headers.completion'),
					name: 'completion',
					value: 'completion',
					width: 60,
					noNotAvailableText: true,
					cellClass: 'font-weight-bold',
					setValueExpr: val => val + '%'
				},
			];

			for (let i = 0; i < headers.length; i++) {
				headers[i].columnClass = headers[i].columnClass ? headers[i].columnClass + ' px-1' : 'px-1';
				headers[i].align = 'center';
			}

			return [
				headers,
				...this.itemsHeaders,
				{
					text: this.$T('headers.total') + ' (kg)',
					name: 'total',
					value: 'total',
					align: 'center',
					width: 66,
					cellClass: 'font-weight-bold',
					columnClass: 'px-1',
					type: 'number-format',
				},
			].flat();
		},

		itemsHeaders() {
			const subTreeItemId = this.cardamomRootId || this.itemsTree[0].id;
			if (!subTreeItemId) return;
			const subTree = this.itemsTree.find(c => c.id === subTreeItemId);

			const headers = [];

			const getHeaderColor = (priority) => {
				switch (priority) {
				case 1: return 'primary-priority-1';
				case 2: return 'secondary-priority-1';
				case 3: return 'thirdly-priority-1';
				default: return '';
				}
			}
			const getCellColor = (priority) => {
				switch (priority) {
				case 1: return 'primary-priority-2';
				case 2: return 'secondary-priority-2';
				}
				if (priority < 10) {
					return `thirdly-priority-${priority - 1}`
				}
				return ''
			}

			subTree.children.filter(c => c.itemCategory === itemCategory.commercial).forEach((c, i) => {
				if (c.children.length) {
					c.children.forEach(e => {
						headers.push({
							text: e.name,
							name: e.name,
							value: e.id,
							align: 'center',
							width: 58,
							type: 'number-format',
							class: getHeaderColor(i < 2 ? i + 1 : 3),
							cellClass: getCellColor(i + 1),
							columnClass: 'px-1'
						})
					});
				} else {
					headers.push({
						text: c.name,
						name: c.name,
						value: c.id,
						align: 'center',
						width: 58,
						type: 'number-format',
						class: getCellColor(i < 2 ? i + 1 : 3),
						cellClass: getCellColor(i + 1),
						columnClass: 'px-1'
					});
				}
			})

			return headers;
		},
	},

	methods: {
		getOwnerById(id) {
			let item = null
			if (id !== null && id !== undefined) {
				item = this.getAccountById(id)?.name !== undefined ? this.getAccountById(id)?.name : '-'
			} else {
				item = 'Ugarit'
			}
			return item
		},
		toKiloGram,
		fixNumber 
	},

	created() {
		if (this.isAdmin) {
			this.itemStatLoading = true
			Promise.all([
				this.$store.dispatch('statistics/fetchItemStatistics'),
				this.$store.dispatch('statistics/fetchAvailableToSellByOwners')
			]).then((data) => {
				this.totals.totalSale =
					this.itemsStatistics.totalSaleResponses?.map(c => ({ [c.itemId]: (fixNumber(c.totalSales)) }))
			
				this.totalSaleSum =
					this.itemsStatistics.totalSaleResponses?.reduce((res, a) => res + (fixNumber(a.totalSales)), 0);

				this.totals.inventoryQuantity = this.itemsStatistics.inventoryItemsResponses?.map(c => ({ [c.itemId]: (fixNumber(c.remainingQty)) }))
				this.inventoryQuantitySum =
				this.itemsStatistics.inventoryItemsResponses?.reduce((res, a) => res + (fixNumber(a.remainingQty)), 0);

				// to able sell
				const ableToSell = data[1][0]?.items;
				this.totals.saleBalances = ableToSell.map(c => ({ [c.itemId]: toKiloGram(c.expectedQuantity) }))

				this.totals.ableToSell = ableToSell.map(c => ({ [c.itemId]: toKiloGram(c.availableToSell) }))

				const headerItemIds = this.itemsHeaders.map(h => h.value);
				const filteredData = ableToSell.filter(item => headerItemIds.includes(item.itemId));
				this.ableToSellSum = filteredData.reduce((sum, item) => sum + toKiloGram(item.availableToSell), 0);

				this.saleBalancesSum = filteredData.reduce((sum, item) => sum + toKiloGram(item.expectedQuantity), 0);
			}).finally(() => {
				this.itemStatLoading = false
			})
		}
	}
}
</script>

<style lang="scss" scoped>
#home {
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

</style>